/**
 * Issues JavaScript singleton module
 */

var Issues = (function($) {

  function initIssues() {
    $('.issue__slider').slick({
      infinite: false,
      adaptiveHeight: false,
      slide : '.issue__slide',
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      responsive: [
        {
            breakpoint: 768,
            settings: {
                adaptiveHeight: true
            }
        }
    ]
    });

    $('.issue-gallery').slick({
      infinite: false,
      lazyLoad: 'ondemand',
      responsive: [
        {
            breakpoint: 768,
            settings: {
              autoplay: true,
              autoplaySpeed: 3000,
              pauseOnFocus: true,
            }
        }
    ]
    });
  }

  function init() {

    // return early if no corresponding module present
    if (!$('.issue').length) {
      return;
    }

    initIssues();

  }

  return {
    init: init
  };

}(jQuery));

jQuery(document).ready(Issues.init);
